import { useState } from "react";
import { Form, Button, Card, Typography } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { setAuthLogin } from "../redux/slices/isAuth";
import { useDispatch } from "react-redux";
import { redirectToDashboard } from "../utils/RedirectRoute";
import { useApiCall } from "../services/api";
import { useNavigate } from "react-router-dom";
import Success from "../components/models/Success";
import AppInput from "../common/FormInputs/AppInput";
import { useToast } from "../utils/Toast";
import { commonRule } from "../constant";

const Login = () => {
  const { callApi } = useApiCall();
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const { Title, Text } = Typography;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loginRole, setLoginRole] = useState(null);
  const toast = useToast();

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const { status, responseData } = await callApi({
        endpoint: "auth/login",
        bodyData: values,
        apiMethod: "post",
        useToken: false,
      });

      if (status) {
        setLoginRole(responseData?.data?.role);
        setIsModalOpen(true);
        setTimeout(() => {
          dispatch(setAuthLogin(responseData?.data));
          redirectToDashboard(responseData?.data?.role, navigate);
        }, 2000);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormChange = (_, allValues) => {
    const { username, password } = allValues;
    setIsButtonDisabled(!username || !password);
  };

  return (
    <>
      <div className="container-fluid vh-100">
        <div className="row h-100">
          {/* Left side */}
          <div
            style={{ background: "#052659" }}
            className="col-md-6 d-flex flex-column justify-content-center align-items-center text-white text-center p-4"
          >
            <img src="../../assets/flexco.png" alt="Logo" style={{ width: "350px" }} />
            {/* <h3 className="fw-bold">QA Analysis Dashboard</h3> */}
            {/* <p style={{ fontSize: "22px", color: "#BDBDBD" }}>
              Evaluate calls, assign reviews, track QA performance, and manage users all in one
              unified platform.
            </p> */}
          </div>

          {/* Right side */}
          <Card className="col-md-6 d-flex align-items-center justify-content-center p-4">
            <div className="text-center">
              <Title level={1} style={{ marginBottom: "0px" }}>
                Welcome to the Admin Panel
              </Title>
              <Text style={{ fontSize: "24px", fontWeight: "400" }}>
                Please log in to access your dashboard.
              </Text>
            </div>

            <Form
              form={form}
              className="p-4"
              name="login"
              style={{ marginTop: 20 }}
              onFinish={handleSubmit}
              layout="vertical"
              onValuesChange={handleFormChange}
              requiredMark={false}
            >
              <AppInput
                label={
                  <span>
                    User ID<span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="username"
                type="text"
                placeholder="Enter your User ID"
                suffix={<UserOutlined />}
                rules={[
                  {
                    required: true,
                    message: "Please check and enter a valid user ID",
                  },
                ]}
              />

              <AppInput
                label={
                  <span className="mt-3">
                    Password<span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="password"
                placeholder="Enter your password"
                type="password"
                suffix={<LockOutlined />}
                rules={commonRule}
              />

              <Form.Item>
                <Button
                  style={{
                    padding: "20px",
                    marginTop: "44px",
                    background: "#052659",
                    color: "#ffffff",
                    fontSize: "20px",
                  }}
                  type="primary"
                  htmlType="submit"
                  block
                  disabled={isButtonDisabled || isLoading}
                >
                  {isLoading ? "Logging in..." : "Login"}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
      <Success handleCancel={handleCancel} open={isModalOpen} mode={"login"} role={loginRole} />
    </>
  );
};

export default Login;
